var country_codes_to_currencies = false;
(function($, document, window, undefined) {
  window.getUserLocation = {
    init: function(settings) {
      // Assignment
      var self = this;
        
      self.settings = settings;
      self.redirect = localStorage.getItem("location-redirect");
      self.messageWrap = $("#location-redirect-message");
      self.currentCountry = $('.current-country', self.messageWrap);
      self.RedirectMe = $('.redirect-me', self.messageWrap);
      self.closeBtn = $('.close-redirect-btn', self.messageWrap);
      self.newStore = $('.new-store', self.messageWrap);

      self.catchAllCountries = settings["redirect_catch_all_countries"];
      self.catchAllURL = settings["redirect_catch_all_url"];
      self.catchAllName = settings["redirect_catch_all_name"];

      self.forceRedirect = settings["redirect_force"] ? true : false;
      self.countryTranslations = {
        "Sweden": "Sverige"
      };
      self.domain = "https://server.shortcodesforshopify.com/json/?callback=?";
      self.redirects = [];
      self.urlMap = {};
      self.location = {};

      // Preparation
      self.loadRedirects(settings);
      self.mapURLs(self.redirects, "::");
      self.redirect = (typeof self.redirect == "string") ? JSON.parse(self.redirect) : {shown: false, date: null};
      self.redirect.shown = self.getIsRedirectShown();

      // Initialization successful
      return true;
    },
    run: function() {
      var self = this;

      var successCallback = self.storeLocation,
        activateRedirect = ( ! self.redirect.shown || self.forceRedirect ) ? true : false;

      if( activateRedirect ) {
        self.makeServerCall( self.fetchLocationInfoAndRunCallback, successCallback );
      }
    },
    loadRedirects: function(settings) {
      var self = this;
      for(var i = 1; i < 11; ++i) {
        var name = "redirect_" + i;

        self.redirects.push( settings[name] );
      }
    },
    mapURLs: function(stringList, splitter) {
      var self = this;

      for(var i = 0; i < stringList.length; ++i) {
        if( stringList[i] && stringList[i] != "") {
          var splitString = stringList[i].split(splitter);

          if(splitString[2].indexOf("http://") === -1 && splitString[1].indexOf("https://") === -1 ) {
            splitString[2] = "http://" + splitString[2];
          }

          self.urlMap[splitString[0]] = {
            "name": splitString[1],
            "url": splitString[2]
          };
        }
      }

      if(self.catchAllCountries.length > 0) {
        var countries = self.catchAllCountries.split(/[\s,]+/);

        for(var i = 0; i < countries.length; ++i) {
          self.urlMap[ countries[i] ] = {
            "name": self.catchAllName,
            "url": self.catchAllURL
          }
        }
      }

      return self.urlMap;
    },
    getIsRedirectShown: function() {
      var self = this,
        today = new Date(),
        prevDate = new Date(self.redirect.date),
        dayLength = 1000 * 24 * 60 * 60, // in milliseconds
        diffDate = today - prevDate;

      // display query again if localStorage is older than 30 days
      if( diffDate / dayLength > 30 )
        return false;

      return true;
    },
    makeServerCall: function( serverCall, callback ) {
      return serverCall(callback);
    },
    fetchLocationInfoAndRunCallback: function( successCallback ) {
      var self = getUserLocation;

      $.ajax( {
        url: self.domain,
        type: 'POST',
        dataType: 'jsonp',
        async: false,
        success: successCallback,
        error: successCallback
      });
    },
    storeLocation: function( location ) {
      var self = getUserLocation;

      self.location = location;

      localStorage.setItem("user-location", (JSON.stringify(location)));

      try {
        if ( self.urlMap[location.country_code].url != null ) {
          var countryName = (self.countryTranslations[location.country_name]) ? self.countryTranslations[location.country_name] : location.country_name;
          
          self.currentCountry.text(countryName);
          self.newStore.text( self.urlMap[location.country_code].name );
          self.RedirectMe.attr("href", self.urlMap[location.country_code].url);
          self.messageWrap.show();
        }
      } catch(err) {
        console.log(err.message);
      }

      console.log(location);

      sessionStorage.setItem('userLocation', location.country_code);
      sessionStorage.setItem('userCountry', location.country_name);

      if (location.country_code == "AU") {
        localStorage.setItem('showGSTPrices', true);
      } else {
        localStorage.setItem('showGSTPrices', false);
      }

      $.when(
        $.getJSON( "//cdn.shopify.com/s/files/1/0057/0707/1588/t/3/assets/currency.json?v=4690529167251755141543472861", function(data) {
          return country_codes_to_currencies = data;
        })
      ).done(function() {
        console.log(country_codes_to_currencies);
        jQuery(document).trigger('user.located');
      });
        
    },
    fetchAndRedirectOnResponse: function( location ) {
      var self = getUserLocation;

      self.location = location;

      if(self.urlMap[location.country_code].url != null) {
        window.location.assign(self.urlMap[location.country_code].url);
      }
    }
  };
})(jQuery, document, window);
